/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';

export function UsFlagIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            viewBox="0 0 64 44"
            width="64"
            height="44"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g>
                <path d="m0 0h64v44h-64z" fill="#fff" />
                <path d="m0 0h32v28h-32z" fill="#1e34b2" />
                <g fill="#fff">
                    <path d="m4 4h4v4h-4z" />
                    <path d="m12 4h4v4h-4z" />
                    <path d="m20 4h4v4h-4z" />
                    <path d="m8 12h4v4h-4z" />
                    <path d="m16 12h4v4h-4z" />
                    <path d="m24 12h4v4h-4z" />
                    <path d="m4 20h4v4h-4z" />
                    <path d="m12 20h4v4h-4z" />
                    <path d="m20 20h4v4h-4z" />
                </g>
                <path d="m32 0h32v4h-32z" fill="#db3f1f" />
                <path d="m32 8h32v4h-32z" fill="#db3f1f" />
                <path d="m32 16h32v4h-32z" fill="#db3f1f" />
                <path d="m32 24h32v4h-32z" fill="#db3f1f" />
                <path d="m0 32h64v4h-64z" fill="#db3f1f" />
                <path d="m0 40h64v4h-64z" fill="#db3f1f" />
            </g>
        </svg>
    );
}

export function GovIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.1951 20.6943C22.6423 20.6943 23 21.0786 23 21.4629V23H1V21.4629C1 20.9825 1.35772 20.6943 1.80488 20.6943H22.1951ZM6.90244 8.87772V18.2926H8.33334V8.87772H11.2846V18.2926H12.7154V8.87772H15.6666V18.2926H17.0975V8.87772H20.0488V18.2926H20.7643C21.2114 18.2926 21.5691 18.6769 21.5691 19.0612V19.8297H2.43089V19.0612C2.43089 18.5808 2.78862 18.2926 3.23577 18.2926H3.95122V8.87772H6.90244ZM12 1L23 5.70742V7.24454H21.5691C21.5691 7.72489 21.2114 8.0131 20.7643 8.0131H3.23577C2.78862 8.0131 2.43089 7.62882 2.43089 7.24454H1V5.70742L12 1Z"
                fill="currentColor"
            />
        </svg>
    );
}
